define('LoyaltyMyAccount.Brithdate.Form', [
    'loyalty_myaccount_birthdateform.tpl',
    'Backbone',
    'Backbone.FormView'
], function LoyaltyMyAccountBrithdateForm(
    loyaltyMyaccountBirthdateformTpl,
    Backbone,
    BackboneFormView
) {
    'use strict';

    return Backbone.View.extend({
        template: loyaltyMyaccountBirthdateformTpl,
        binding: {
            '[name="birthDate"]': 'birthDate'
        },
        events: {
            'click [data-action="saveBirth"]': 'saveBirth'
        },
        initialize: function initialize() {
            BackboneFormView.add(this);
        },
        saveBirth: function saveBirth(e) {
            e.preventDefault();
            this.model.set({
                isBirthdate: true
            });

            this.saveForm(e, this.model);
        }
    });
});
